import { Guid } from '@web/utils';

export class WarehouseReleaseProduct {
  public constructor(
    private readonly data: {
      brandName: string;
      createdAt: Date;
      id: Guid;
      productId: Guid;
      productName: string;
      quantity: number;
      sku: string;
    },
  ) {}

  public get brandName(): string {
    return this.data.brandName;
  }
  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get productId(): Guid {
    return this.data.productId;
  }

  public get productName(): string {
    return this.data.productName;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get sku(): string {
    return this.data.sku;
  }
}
